module.exports = __webpack_public_path__ + "static/img/hzq1118.28d00fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hzq1118.jpg
// module id = pyLf
// module chunks = 0